module.exports = __webpack_public_path__ + "img/adulto46.22910b02.jpg";